import React, { useEffect, useState } from "react";
import { Loader2, AlertTriangle, Sparkles, Zap } from "lucide-react";
import { csuiteApi } from "../../../lib/csuiteApi";

/** AI Insight Feed — 5 curated 3-bullet briefings. Pro tier badge visible. */
export default function InsightsFeed() {
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => { csuiteApi.insights().then(setD).catch(e => setErr(e.message)); }, []);
  if (err) return <div className="p-6 text-red-700 flex items-center gap-2"><AlertTriangle size={16}/>{err}</div>;
  if (!d) return <div className="p-10 grid place-items-center"><Loader2 className="animate-spin text-sky-700"/></div>;
  const tierIsPro = d.tier === "pro";
  return (
    <div data-testid="platinum-insights">
      <div className="mb-4 flex items-start justify-between flex-wrap gap-2">
        <div>
          <div className="font-mono text-[10px] uppercase tracking-widest text-zinc-500 flex items-center gap-2">
            <Sparkles size={12}/> AI Insight Feed
            <span className={`pill text-[10px] ${tierIsPro ? "pill-green" : "pill-neutral"}`}>
              {tierIsPro ? "Proactive · Platinum" : "Digest · Starter"}
            </span>
          </div>
          <h2 className="font-display text-2xl font-extrabold tracking-tight">Daily executive briefings</h2>
          <div className="text-sm text-zinc-500 mt-1">Curated by Claude 4.5 · refreshed at each portal login</div>
        </div>
      </div>

      <div className="grid md:grid-cols-2 gap-4">
        {d.items.map((item, i) => (
          <div key={item.id} className="card p-4" data-testid={`insight-card-${i}`}>
            <div className="flex items-start justify-between mb-2">
              <div>
                <div className="font-mono text-[10px] uppercase tracking-widest text-zinc-500">{item.date}</div>
                <div className="font-display text-base font-bold tracking-tight text-zinc-900 mt-1">{item.title}</div>
              </div>
              <Zap size={16} style={{ color: "#B03A48" }} />
            </div>
            <ul className="text-sm space-y-1.5 mt-2 pl-4 list-disc" style={{ listStyleColor: "#B03A48" }}>
              {item.bullets.map((b, j) => <li key={j} className="leading-relaxed">{b}</li>)}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
}
